module.exports = __webpack_public_path__ + "img/tb(9).b635fed9.png";